import React from 'react';

import {IconoirLayoutLeft} from '@ey-xd/motif-icon';
import NavLink from './NavLink';

export default (label, currentProjectId) => ({
	id: 4,
	key: 4,
	url: 4, // CCS TopNav component sets link.url as the key for links this is set up to supress that warning on the console
	className: 'dashboard',
	isLink: false,
	children: (
		<NavLink {...{label, icon: IconoirLayoutLeft, solid: false, url: `/dashboard?projectId=${currentProjectId}`}} />
	)
});
